<template>
  <v-app>
    <v-navigation-drawer app v-model="drawer">
      <v-list dense>
        <v-list-item>
          <v-list-item-avatar>
            <v-img :src="userImage"></v-img>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ user.nombre || 'Usuario' }}</v-list-item-title>
            <v-list-item-subtitle>{{ user.tipo || 'Sin rol' }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="my-3"></v-divider>

        <!-- MENÚ PROVEEDOR -->
        <template v-if="user.tipo === 'Proveedor'">
          <v-list-item link @click="go('/home/proveedor')">
            <v-list-item-icon><v-icon>mdi-view-dashboard</v-icon></v-list-item-icon>
            <v-list-item-title>Dashboard</v-list-item-title>
          </v-list-item>

          <v-list-item link @click="go('/home/pedidos')">
            <v-list-item-icon><v-icon>mdi-cart</v-icon></v-list-item-icon>
            <v-list-item-title>Pedidos</v-list-item-title>
          </v-list-item>

          <v-list-item link @click="go('/home/documentos')">
            <v-list-item-icon><v-icon>mdi-file-document</v-icon></v-list-item-icon>
            <v-list-item-title>Documentos</v-list-item-title>
          </v-list-item>

          <v-list-item link @click="go('/home/productos')">
            <v-list-item-icon><v-icon>mdi-package-variant</v-icon></v-list-item-icon>
            <v-list-item-title>Productos</v-list-item-title>
          </v-list-item>
        </template>

        <!-- MENÚ INVENTARIO 
        <template v-else-if="user.tipo === 'Inventario'">
          <v-list-item link @click="go('/home/inventario')">
            <v-list-item-icon><v-icon>mdi-view-dashboard</v-icon></v-list-item-icon>
            <v-list-item-title>Dashboard</v-list-item-title>
          </v-list-item>

          <v-list-item link @click="go('/home/carga-descarga')">
            <v-list-item-icon><v-icon>mdi-truck-fast</v-icon></v-list-item-icon>
            <v-list-item-title>Carga y descarga</v-list-item-title>
          </v-list-item>
        </template>-->

        <!-- MENÚ CAJERO -->
        <template v-else-if="user.tipo === 'Cajero'">
          <v-list-item link @click="go('/home/cajero')">
            <v-list-item-icon><v-icon>mdi-cash-register</v-icon></v-list-item-icon>
            <v-list-item-title>Dashboard Cajero</v-list-item-title>
          </v-list-item>
        </template>

        <!-- MENÚ DIRECCION -->
        <template v-else-if="user.tipo === 'Direccion'">
          <v-list-item link @click="go('/home/direccion')">
            <v-list-item-icon><v-icon>mdi-office-building</v-icon></v-list-item-icon>
            <v-list-item-title>Dashboard Dirección</v-list-item-title>
          </v-list-item>
        </template>

        <!-- MENÚ SISTEMAS -->
        <template v-else-if="user.tipo === 'Sistemas'">
          <v-list-item link @click="go('/home/sistemas')">
            <v-list-item-icon><v-icon>mdi-laptop</v-icon></v-list-item-icon>
            <v-list-item-title>Dashboard Sistemas</v-list-item-title>
          </v-list-item>
        </template>

      <!-- MENÚ ALMACEN -->
<!-- MENÚ ALMACEN -->
<template v-else-if="user.tipo === 'Almacen' || user.tipo === 'Inventario'">

  <v-list-group
    prepend-icon="mdi-warehouse"
    v-model="menuAlmacen"
    color="primary"
  >
    <template v-slot:activator>
      <v-list-item-title>
        Almacén
      </v-list-item-title>
    </template>

    <!-- SUBMENU CARGA -->
    <v-list-group
      sub-group
      v-model="menuCarga"
    >
      <template v-slot:activator>
        <v-list-item-content>
          <v-list-item-title>
            Carga
          </v-list-item-title>
        </v-list-item-content>
      </template>

      <!-- SOLO ALMACEN -->
      <v-list-item
        v-if="user.tipo === 'Almacen'"
        link
        @click="go('/home/almacen/carga')"
      >
        <v-list-item-icon>
          <v-icon>mdi-view-dashboard</v-icon>
        </v-list-item-icon>

        <v-list-item-title>
          Dashboard Carga
        </v-list-item-title>
      </v-list-item>

      <!-- ALMACEN E INVENTARIO -->
      <v-list-item
        v-if="user.tipo === 'Almacen' || user.tipo === 'Inventario'"
        link
        @click="go('/home/almacen/carga-tiempo-real')"
      >
        <v-list-item-icon>
          <v-icon>mdi-truck-fast</v-icon>
        </v-list-item-icon>

        <v-list-item-title>
          Carga en Tiempo Real
        </v-list-item-title>
      </v-list-item>

      <!-- SOLO ALMACEN -->
      <v-list-item
        v-if="user.tipo === 'Almacen'"
        link
        @click="go('/home/almacen/carga-consulta-x-fecha')"
      >
        <v-list-item-icon>
          <v-icon>mdi-calendar-search</v-icon>
        </v-list-item-icon>

        <v-list-item-title>
          Consulta por Fecha
        </v-list-item-title>
      </v-list-item>

    </v-list-group>

    <!-- SUBMENU DESCARGA -->
    <v-list-group
      v-if="user.tipo === 'Almacen'"
      sub-group
      v-model="menuDescarga"
    >
      <template v-slot:activator>
        <v-list-item-content>
          <v-list-item-title>
            Descarga
          </v-list-item-title>
        </v-list-item-content>
      </template>

      <v-list-item
        link
        @click="go('/home/almacen/descarga')"
      >
        <v-list-item-icon>
          <v-icon>mdi-view-dashboard</v-icon>
        </v-list-item-icon>

        <v-list-item-title>
          Inicio Descarga
        </v-list-item-title>
      </v-list-item>

      <v-list-item
        link
        @click="go('/home/almacen/descarga-tiempo-real')"
      >
        <v-list-item-icon>
          <v-icon>mdi-truck-fast</v-icon>
        </v-list-item-icon>

        <v-list-item-title>
          Descarga en Tiempo Real
        </v-list-item-title>
      </v-list-item>

      <v-list-item
        link
        @click="go('/home/almacen/descarga-fecha')"
      >
        <v-list-item-icon>
          <v-icon>mdi-calendar-search</v-icon>
        </v-list-item-icon>

        <v-list-item-title>
          Consulta por Fecha
        </v-list-item-title>
      </v-list-item>

    </v-list-group>

  </v-list-group>

</template>
        <v-divider class="my-3"></v-divider>

        <v-list-item link @click="logout">
          <v-list-item-icon><v-icon>mdi-logout</v-icon></v-list-item-icon>
          <v-list-item-title>Cerrar sesión</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="primary" dark>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Portal</v-toolbar-title>
      <v-spacer></v-spacer>
      <span>{{ user.nombre || '' }}</span>
    </v-app-bar>

    <v-main class="main-content">
      <v-container fluid class="pb-12">
        <router-view />
      </v-container>
    </v-main>

    <!-- FOOTER FIJO Y ALINEADO AL MENÚ LATERAL -->
    <v-footer
      app
      inset
      height="50"
      class="custom-footer"
    >
      <v-container fluid>
        <v-row align="center" justify="space-between" no-gutters>
          <v-col cols="12" sm="6" class="text-center text-sm-left text-caption">
            © {{ new Date().getFullYear() }} Distribuidora de Abarrotes LA Y GRIEGA
          </v-col>

          <v-col cols="12" sm="6" class="text-center text-sm-right text-caption">
            Desarrollado por <strong>ING. Jose de Jesus Villatoro</strong>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
import authService from '@/api/authService'

export default {
  name: 'Home',

  data() {
    return {
      drawer: true,
      user: {},

      // MENUS
      menuAlmacen: false,
      menuCarga: false,
      menuDescarga: false
    }
  },
  computed: {
  userImage() {
    const imagenDefault = require('@/assets/Img/default.png')

    if (this.imagenError) {
      return imagenDefault
    }

    if (!this.user || !this.user.imagen) {
      return imagenDefault
    }

    let imagen = String(this.user.imagen).trim()

    if (imagen.startsWith('file://')) {
      imagen = imagen.replace(
        'file://192.169.1.201',
        'http://192.169.1.201:8080'
      )
    }

    if (!imagen.startsWith('http://') && !imagen.startsWith('https://')) {
      return imagenDefault
    }

    return imagen
  }
},

  created() {
    try {
      this.user = JSON.parse(localStorage.getItem('usuario')) || {}
    } catch (e) {
      this.user = {}
    }
  },

  methods: {
    go(route) {
      if (this.$route.path !== route) {
        this.$router.push(route)
      }
    },

    async logout() {
      const token = localStorage.getItem('token')
      const usuarioClave = localStorage.getItem('usuarioClave')

      try {
        if (token && usuarioClave) {
          await authService.logout(usuarioClave, token)
        }
      } catch (error) {
        console.error('Error al cerrar sesión:', error)
      } finally {
        localStorage.removeItem('token')
        localStorage.removeItem('usuario')
        localStorage.removeItem('usuarioClave')

        this.$router.push('/login')
      }
    }
  }

  
}
</script>

<style scoped>
.v-avatar img {
  border: 2px solid #1976d2;
  border-radius: 50%;
}

.main-content {
  padding-bottom: 50px;
}

.custom-footer {
  background: linear-gradient(90deg, #1976d2, #0d47a1);
  color: white;
  font-size: 13px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
}

.custom-footer strong {
  font-weight: 600;
}

@media (max-width: 600px) {
  .custom-footer {
    height: auto !important;
    min-height: 58px;
    padding-top: 6px;
    padding-bottom: 6px;
  }
}
</style>